import { useSelector, useDispatch } from "react-redux";
import { get as _get } from "lodash";
// components mui
import { Box, Modal, Button, Typography } from "@mui/material";

// icons
import AddIcon from "@mui/icons-material/Add";

// Actions
import { setModalData, setModal } from "../../../redux/actions/modals";
import { setPositions } from "../../../redux/actions/liquidity";
import { setImportAssetOne, setImportAssetTwo } from "../../../redux/actions/positions";

// components
import TokenInputPanel from "../../TokenSelectPanel";
import ModalHeader from "./../ModalHeader";

// helpers
import LS from "./../../../helpers/storage";

const ModalImportToken = () => {
  // hooks
  const dispatch = useDispatch();

  // selectors
  const currentModal = useSelector((state) => state.modals.modal);
  // const currentModalData = useSelector((state) => state.modals.data);
  // positions
  const importAssetOne = useSelector((state) => state.positions.assetOne);
  const importAssetTwo = useSelector((state) => state.positions.assetTwo);
  const positions = useSelector((state) => state.liquidity.positions);

  // functions
  const openModalSelectToken = (data) => {
    dispatch(setModalData(data));
    dispatch(setModal("SelectToken"));
  };
  const closeModal = () => {
    dispatch(setModal(null));
    dispatch(setModalData(null));
    dispatch(setImportAssetOne(null));
    dispatch(setImportAssetTwo(null));
  };

  const importPosition = () => {
    let position = {
      tokenA: _get(importAssetOne, "address", ""),
      tokenB: _get(importAssetTwo, "address", ""),
    };
    let checkPosiution = positions.find(
      (p) =>
        (p.tokenA === position.tokenA && p.tokenB === position.tokenB) ||
        (p.tokenA === position.tokenB && p.tokenB === position.tokenA)
    );
    if (!checkPosiution) {
      let newPositionsArray = [...positions, position];
      // save to localStorage
      LS.custom_positions(newPositionsArray);
      dispatch(setPositions(newPositionsArray));
    }
    closeModal();
  };

  return (
    <Modal open={currentModal === "ImportPosition"} onClose={closeModal} sx={{ display: "flex", p: 2 }}>
      <Box sx={{ width: "100%", maxWidth: 420, m: "auto" }}>
        <ModalHeader title={"Import position"} closeFunction={closeModal} backArrow={null} />
        <Box sx={{ px: 2.5, pb: 2.5 }}>
          <Typography variant="body2" sx={{ color: "text.secondary", mb: 2 }}>
            Pick the two tokens of a pool to show your position in it.
          </Typography>
          <TokenInputPanel
            onSelect={() => openModalSelectToken({ reduce: "position", value: "importAssetOne" })}
            token={importAssetOne}
          />
          <Box sx={{ display: "flex", justifyContent: "center", my: 1, color: "text.secondary" }}>
            <AddIcon fontSize="small" />
          </Box>
          <TokenInputPanel
            onSelect={() => openModalSelectToken({ reduce: "position", value: "importAssetTwo" })}
            token={importAssetTwo}
          />
          <Button
            fullWidth
            size="large"
            sx={{ mt: 2.5 }}
            onClick={importPosition}
            variant="contained"
            disabled={!importAssetOne || !importAssetTwo}
          >
            Import position
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default ModalImportToken;
